<template lang="pug">
.briq-form-element
  label {{ label }}
  span.optional-marker Optional
  .flex
    .briq-radio-row-button(v-for="option in options")
      label
        input(type="radio" v-model="innerValue" :value="option.value")
        span {{ option.label }}
</template>

<script>
import { converge, and, has, reduce } from 'ramda'

function optionsAreValid(options) {
  if (options.length === 0) return false
  const optionIsValid = converge(and, [has('label'), has('value')])
  const reducer = reduce((agg, next) => agg && optionIsValid(next), true)
  return reducer(options)
}

export default {
  name: 'BriqRadioRow',
  props: {
    label: String,
    options: {
      type: Array,
      required: true,
      validator: optionsAreValid,
    },
    value: [Object, String],
  },
  data() {
    return {
      innerValue: this.value,
    }
  },
  watch: {
    innerValue(newVal) {
      this.$emit('input', newVal)
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/variables.styl'

.briq-radio-row-button
  margin-right space-XXS

  input
    position absolute
    width 0
    height 0
    opacity 0

  label
    font-weight 500
    cursor pointer
    margin 0
    display flex

  span
    {typeStandard}
    border 1px solid #ececec
    display flex
    justify-content center
    align-items center
    padding 2px 12px
    border-radius 3px

  span:hover
    border-color #2c333a
    color black

  input:checked + span
    background: #4e5a6a;
    border-color: #4e5a6a;
    color: #fff;

.briq-radio-row-button:last-child
  margin-right 0
</style>
